import {insert, isNil, sortBy} from 'ramda';

import {ChartVariant} from '../types/ChartVariant';
import {ExtendedStatisticsCar} from '../types/ExtendedStatisticsCar';
import {getChartCoordinates} from './getChartCoordinates';

export const sortStatisticsCarsForChart = (
  cars: ExtendedStatisticsCar[],
  chartVariant: ChartVariant
): ExtendedStatisticsCar[] => {
  if (chartVariant === 'priceMap' || chartVariant === 'mapView') {
    return cars;
  }

  const myVehicle = cars.find((car) => car.isMyVehicle);
  const competitors = cars.filter((car) => !car.isMyVehicle);
  const sortedCompetitors = sortBy((car) => getChartCoordinates(car, chartVariant).y, competitors);

  const carsWithMyVehicle = isNil(myVehicle)
    ? sortedCompetitors
    : (() => {
        const myVehicleY = getChartCoordinates(myVehicle, chartVariant).y;
        const insertIndex = sortedCompetitors.findIndex(
          (car) => getChartCoordinates(car, chartVariant).y > myVehicleY
        );

        return insert(
          insertIndex === -1 ? sortedCompetitors.length : insertIndex,
          myVehicle,
          sortedCompetitors
        );
      })();

  return carsWithMyVehicle.map((car, index) => ({
    ...car,
    position: index + 1,
  }));
};
